// extracted by mini-css-extract-plugin
export var container = "what-sauna-module--container--63d11";
export var content = "what-sauna-module--content--673d4";
export var contentWrapper = "what-sauna-module--contentWrapper--ab820";
export var imageLabel = "what-sauna-module--imageLabel--93397";
export var largeLabel = "what-sauna-module--largeLabel--3ef0a";
export var quiz = "what-sauna-module--quiz--34c28";
export var roomSelection = "what-sauna-module--roomSelection--d8d2d";
export var section = "what-sauna-module--section--3d89c";
export var selection = "what-sauna-module--selection--172e3";
export var selections = "what-sauna-module--selections--09a0a";
export var smallLabel = "what-sauna-module--smallLabel--37f6e";